import { SpeakerphoneIcon, XIcon } from '@heroicons/react/outline';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import React from 'react';
import lscache from 'lscache';
import { daysToMinutes } from '../../utils/dateUtils';
import bannerConfig from '../../config/bannerConfig.json';

function Banner () {
  // Version-aware dismiss key — bumping bannerConfig.version re-shows the banner
  // to users who dismissed a previous version.
  const IS_BANNER_CLOSED_CACHE_KEY = `isBannerClosed_v${bannerConfig.version}`;
  const [isClosed, setIsClosed] = useState(lscache.get(IS_BANNER_CLOSED_CACHE_KEY) === true);

  useEffect(() => {
    lscache.set(IS_BANNER_CLOSED_CACHE_KEY, isClosed, daysToMinutes(7));
  }, [isClosed, IS_BANNER_CLOSED_CACHE_KEY]);

  const showBanner = bannerConfig.enabled && !isClosed;

  return (
    <div className="min-h-[0px]" style={{ minHeight: showBanner ? '48px' : '0px' }}>
      {showBanner && (
        <div className="bg-brand-600">
          <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between flex-wrap">
              <div className="w-0 flex-1 flex items-center">
                <span className="flex p-2 rounded-lg bg-brand-800">
                  <SpeakerphoneIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </span>
                <p className="ml-3 font-medium text-white truncate">
                  <span className="md:hidden">{bannerConfig.mobileTitle}</span>
                  <span className="hidden md:inline">{bannerConfig.desktopTitle}</span>
                </p>
              </div>
              {bannerConfig.linkTo && (
                <div className="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                  <Link
                    to={bannerConfig.linkTo}
                    className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-brand-600 bg-white hover:bg-brand-50"
                  >
                    {bannerConfig.linkText}
                  </Link>
                </div>
              )}
              <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
                <button
                  type="button"
                  className="-mr-1 flex p-2 rounded-md hover:bg-brand-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2"
                  onClick={() => setIsClosed(true)}
                >
                  <span className="sr-only">Dismiss</span>
                  <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Banner;
